import React from "react";
import { useLocation } from "react-router-dom";
import { Input, InputGroup } from "reactstrap";

const SearchBar = ({
  inputRef,
  value,
  onChange,
  placeholder,
  shouldDisplaySearchBar,
}) => {
  return (
    <InputGroup className={`search-bar ${shouldDisplaySearchBar ? "" : ""}`}>
      <span
        className="search-icon ps-2 position-absolute"
        onClick={() => inputRef.current.focus()}
        style={{ zIndex: 1, cursor: "text" }}
      >
        <i className="ri-search-line text-muted fs-3"></i>
      </span>
      <Input
        innerRef={inputRef}
        className="search-input py-2"
        style={{
          borderRadius: "5px",
          zIndex: 0,
          paddingLeft: "40px",
        }}
        placeholder="Filter by ID, name, or email"
        value={value}
        onChange={onChange}
      />
    </InputGroup>
  );
};

export default SearchBar;
